import { Link as MuiLink } from "@mui/material";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, ProSidebar, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, NavLink } from "react-router-dom";
import "../../dashboard-layout/_sidebar/Sidebar.scss";

const btn_audit_free = {
  style_btn: {
    fontSize: "15px",
    background: "rgb(66 133 244)",
    borderRadius: "5px",
    padding: "5px 15px",
  },
  style_a: {
    fontSize: "15px",
    color: "#fff",
  },
  a_span: {
    fontSize: "15px",
    color: "#fff",
    paddingLeft: "5px",
  },
};

function Sidebar(props) {
  const { t } = useTranslation();

  const productionItems = [
    {
      module_id: 1,
      module_name: `${t("sidebar.mainItem.1")}`,
      icon_class: "fas fa-search",
      module_item: [
        // {
        //   id: 1,
        //   name: `${t("sidebar.subItem.1.4")}`,
        //   icon_class: "fas fa-tags",
        //   link_url: "white-label",
        // },
        {
          id: 2,
          name: `${t("sidebar.subItem.1.1")}`,
          icon_class: "far fa-file",
          link_url: "audit-page",
        },
        {
          id: 4,
          name: `${t("sidebar.subItem.1.5")}`,
          icon_class: "fas fa-file-alt",
          link_url: "advance-audit-page",
        },
        {
          id: 5,
          name: `${t("sidebar.subItem.1.6")}`,
          icon_class: "fas fa-desktop",
          link_url: "webpage-audit",
        },
        {
          id: 6,
          name: `${t("sidebar.subItem.1.7")}`,
          icon_class: "fas fa-code",
          link_url: "advance-webpage-audit",
        },
        {
          id: 3,
          name: `${t("sidebar.subItem.1.2")}`,
          icon_class: "fab fa-steam-square",
          link_url: "my-audits",
        },
      ],
    },
    {
      module_id: 2,
      module_name: `${t("sidebar.mainItem.2")}`,
      icon_class: "fab fa-google",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.2.2")}`,
          icon_class: "fas fa-plus",
          link_url: "create-project",
        },
        {
          id: 2,
          name: `${t("sidebar.subItem.2.1")}`,
          icon_class: "fas fa-chart-bar",
          link_url: "admin-site-list",
        },
      ],
    },
    {
      module_id: 3,
      module_name: `${t("sidebar.mainItem.3")}`,
      icon_class: "fab fa-flipboard",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.3.1")}`,
          icon_class: "far fa-edit",
          link_url: "create-widget",
        },
        {
          id: 2,
          name: `${t("sidebar.subItem.3.2")}`,
          icon_class: "fas fa-list-alt",
          link_url: "widget-list",
        },
        {
          id: 3,
          name: `${t("sidebar.subItem.3.3")}`,
          icon_class: "fas fa-house-user",
          link_url: "all-leads",
        },
      ],
    },
    {
      module_id: 4,
      module_name: `${t("sidebar.mainItem.4")}`,
      icon_class: "far fa-user-circle",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.4.1")}`,
          icon_class: "far fa-user",
          link_url: "my-profile",
        },
        {
          id: 2,
          name: `${t("sidebar.subItem.4.2")}`,
          icon_class: "fas fa-money-bill",
          link_url: "billing",
        },
        {
          id: 3,
          name: `${t("sidebar.subItem.4.3")}`,
          icon_class: "fas fa-hand-holding-usd",
          link_url: "pricing",
        },
        {
          id: 4,
          name: `${t("sidebar.subItem.4.4")}`,
          icon_class: "fas fa-envelope-open-text",
          link_url: "manage-subscription",
        },
      ],
    },
  ];

  const devItems = [
    {
      module_id: 5,
      module_name: `${t("sidebar.mainItem.5")}`,
      icon_class: "fas fa-chart-bar",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.5.1")}`,
          icon_class: "far fa-eye",
          link_url: "seo-analyzer",
        },
      ],
    },
    {
      module_id: 6,
      module_name: `${t("sidebar.mainItem.6")}`,
      icon_class: "fas fa-network-wired",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.6.1")}`,
          icon_class: "fas fa-puzzle-piece",
          link_url: "on-page",
        },
        {
          id: 2,
          name: `${t("sidebar.subItem.6.2")}`,
          icon_class: "fab fa-sith",
          link_url: "http-status",
        },
        {
          id: 3,
          name: `${t("sidebar.subItem.6.3")}`,
          icon_class: "fas fa-superscript",
          link_url: "indexing",
        },
        {
          id: 4,
          name: `${t("sidebar.subItem.6.4")}`,
          icon_class: "fas fa-bong",
          link_url: "canonical",
        },
      ],
    },
    {
      module_id: 7,
      module_name: `${t("sidebar.mainItem.7")}`,
      icon_class: "fas fa-desktop",
      module_item: [
        {
          id: 1,
          name: `${t("sidebar.subItem.7.1")}`,
          icon_class: "fas fa-exchange-alt",
          link_url: "page-change-monitor",
        },
        {
          id: 2,
          name: `${t("sidebar.subItem.7.2")}`,
          icon_class: "fab fa-accessible-icon",
          link_url: "monitoring",
        },
        {
          id: 3,
          name: `${t("sidebar.subItem.7.3")}`,
          icon_class: "fas fa-thermometer-quarter",
          link_url: "change-log",
        },
      ],
    },
  ];

  let finalItems;
  const hostName = window.location.host;
  if (
    hostName === "localhost:3000" ||
    hostName === "jasim.creativelab.agency"
  ) {
    finalItems = productionItems.concat(devItems);
  } else {
    finalItems = productionItems;
  }

  const { toggleSidebar, isMenuOpen, classMobile } = props;

  const toggleMobileMenu = () => {
    if (classMobile !== "") {
      toggleSidebar();
    }
  };

  return (
    <div className="sidebar" style={{ zIndex: 2000 }}>
      <div className="side-menu">
        <ProSidebar>
          <Menu className={`main ${isMenuOpen ? "nav-active" : ""}`}>
            {finalItems.map((moduleName) => (
              <Fragment key={moduleName.module_id}>
                <SubMenu
                  icon={<i className={`${moduleName.icon_class}`} />}
                  defaultOpen
                  title={moduleName.module_name}
                >
                  {moduleName.module_item.map((itemName) => (
                    <Fragment key={itemName.id}>
                      <MenuItem
                        icon={<i className={`${itemName.icon_class}`} />}
                      >
                        {itemName.name}
                        <NavLink to={`/${itemName.link_url}`} />
                      </MenuItem>
                    </Fragment>
                  ))}
                </SubMenu>
              </Fragment>
            ))}
          </Menu>
        </ProSidebar>
      </div>

      {/* Unauthenticated user login page  */}
      <div className="authenticate">
        <ul>
          <li className="btn_li">
            <Link
              className="d-block w-100 seo_btn p_16 gradient__orange"
              style={btn_audit_free.style_a}
              to="/audit-page"
              onClick={toggleMobileMenu}
            >
              <i className="far fa-file " />
              <span style={btn_audit_free.a_span}>{t("login.auditPage")}</span>
            </Link>
          </li>
          <li className="btn_li">
            <Link
              className="d-block w-100 seo_btn gradient__orange"
              style={btn_audit_free.style_a}
              to="/pricing"
              onClick={toggleMobileMenu}
            >
              <i className="fas fa-dollar-sign" />
              <span style={btn_audit_free.a_span}>{t("login.pricing")}</span>
            </Link>
          </li>
          <li className="btn_li">
            <h4>{t("login.register")}</h4>
            <p>{t("login.freeFour")}</p>
            <div className="login mt-2">
              <MuiLink
                style={{ width: "100%", display: "block" }}
                component={Link}
                to="/"
                className="seo_btn gradient_blu"
              >
                {t("login.tryItFree")}
              </MuiLink>
              <p className="mt-2">
                <strong>{t("login.toUnlock")}</strong>
              </p>
              <p>{t("login.freemium")}</p>
            </div>
          </li>
          <li />
        </ul>
      </div>
      {/* Unauthenticated user login page  */}
    </div>
  );
}

// const mapStoreToProps = (state) => ({
//   google_token_loading: state.token.google_token_loading,
// });

// const mapDispatchToProps = (dispatch) => ({
//   googleLogin: (email, username) => dispatch(googleLogin(email, username)),
// });
// export default Sidebar;
export default Sidebar;